var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useRequest } from "../../hooks/useRequest";
import { dateFilterValuesGenerator, generateQueryParams } from "../../utils";
export var useCallAnalytics = function () {
    var request = useRequest();
    var _a = useState(null), trendingChartData = _a[0], setTrendingChartData = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    // Funnel Chart State
    var _c = useState(null), funnelChartData = _c[0], setFunnelChartData = _c[1];
    var _d = useState(false), isLoadingFunnel = _d[0], setIsLoadingFunnel = _d[1];
    // Call End Reason Chart State
    var _e = useState(null), endReasonStats = _e[0], setEndReasonStats = _e[1];
    var _f = useState(false), isLoadingEndReasonStats = _f[0], setIsLoadingEndReasonStats = _f[1];
    var _g = useState([]), flows = _g[0], setFlows = _g[1];
    // Fetch available flows
    var getFlows = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get("/CallConversationAnalytics/call-conversation/flows")];
                case 1:
                    response = _a.sent();
                    setFlows(response.data);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Failed to fetch flows:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getTrendingChartData = function (filter, grouping, flowId, customStartDate, customEndDate) { return __awaiter(void 0, void 0, void 0, function () {
        var timeZone, dateFilter, queryParams, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    dateFilter = dateFilterValuesGenerator(filter, customStartDate, customEndDate);
                    queryParams = generateQueryParams(__assign(__assign({}, dateFilter), { grouping: grouping, timeZone: timeZone, flowId: flowId }));
                    return [4 /*yield*/, request.get("/CallConversationAnalytics/call-conversation/trending?".concat(queryParams))];
                case 2:
                    response = _a.sent();
                    setTrendingChartData(response.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error("Failed to fetch trending chart data:", error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // ------------------------------------------------------------
    // Fetch funnel data
    // ------------------------------------------------------------
    var getFunnelChartData = function (filter, grouping, conversionCriteriaInSeconds, flowId, customStartDate, customEndDate) { return __awaiter(void 0, void 0, void 0, function () {
        var timeZone, dateFilter, queryParams, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingFunnel(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    dateFilter = dateFilterValuesGenerator(filter, customStartDate, customEndDate);
                    queryParams = generateQueryParams(__assign(__assign({}, dateFilter), { grouping: grouping, timeZone: timeZone, conversionCriteriaInSeconds: conversionCriteriaInSeconds, flowId: flowId }));
                    return [4 /*yield*/, request.get("/CallConversationAnalytics/call-conversation/funnel?".concat(queryParams))];
                case 2:
                    response = _a.sent();
                    setFunnelChartData(response.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    console.error("Failed to fetch funnel chart data:", error_3);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingFunnel(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // ------------------------------------------------------------
    // Fetch call end reason stats
    // ------------------------------------------------------------
    var getCallEndReasonStats = function (filter, flowId, customStartDate, customEndDate) { return __awaiter(void 0, void 0, void 0, function () {
        var timeZone, dateFilter, queryParams, response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingEndReasonStats(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    dateFilter = dateFilterValuesGenerator(filter, customStartDate, customEndDate);
                    queryParams = generateQueryParams(__assign(__assign({}, dateFilter), { timeZone: timeZone, flowId: flowId }));
                    return [4 /*yield*/, request.get("/CallConversationAnalytics/call-conversation/end-reason-stats?".concat(queryParams))];
                case 2:
                    response = _a.sent();
                    setEndReasonStats(response.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_4 = _a.sent();
                    console.error("Failed to fetch call end reason stats:", error_4);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingEndReasonStats(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        trendingChartData: trendingChartData,
        isLoading: isLoading,
        getTrendingChartData: getTrendingChartData,
        funnelChartData: funnelChartData,
        isLoadingFunnel: isLoadingFunnel,
        getFunnelChartData: getFunnelChartData,
        endReasonStats: endReasonStats,
        isLoadingEndReasonStats: isLoadingEndReasonStats,
        getCallEndReasonStats: getCallEndReasonStats,
        flows: flows,
        getFlows: getFlows,
    };
};
